import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ensureFreshTenantSession } from '../api/session';
import { useAuthStore } from '../store/authStore';

/**
 * Guards tenant routes and silently renews JWT before it expires
 * so API calls do not surface "Invalid or expired access token".
 */
export function RequireAuth() {
  const token = useAuthStore((s) => s.accessToken);
  const refreshToken = useAuthStore((s) => s.refreshToken);
  const location = useLocation();

  useEffect(() => {
    if (!token || !refreshToken) return;

    let cancelled = false;
    const run = () => {
      if (cancelled) return;
      void ensureFreshTenantSession();
    };

    run();
    const id = window.setInterval(run, 30_000);
    const onFocus = () => run();
    window.addEventListener('focus', onFocus);

    return () => {
      cancelled = true;
      window.clearInterval(id);
      window.removeEventListener('focus', onFocus);
    };
  }, [token, refreshToken]);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
